const version = window.OC?.config?.version?.split(".")[0] || "34";
const major = Number.parseInt(version);
const isLegacy32 = major < 32;
const isLegacy34 = major < 34;
export {
  isLegacy32 as a,
  isLegacy34 as i
};
//# sourceMappingURL=legacy-DV3mGZdh.mjs.map
